import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RolePermissionsLayer from "../components/RolePermissionsLayer";

const RoleManagementPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Role Management" />
      <RolePermissionsLayer />
    </MasterLayout>
  );
};

export default RoleManagementPage;
